import * as DB from "@/api/msgCenter.js"
import { request as Require } from "@/utils/require.js"
import { Toast } from "vant"

const state = () => ({})

const mutations = {}

const actions = {

    // 获取消息中心数量
    async messageCenterNumber(context, params) {
        const r = await Require({
            api: DB.messageCenterNumber,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 获取消息模块列表
    async messageModuleList(context, params) {
        const r = await Require({
            api: DB.messageModuleList,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 获取我的消息列表
    async messageList(context, params) {
        const r = await Require({
            api: DB.messageList,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 获取我的待办数量
    async pendingNumber(context, params) {
        const r = await Require({
            api: DB.pendingNumber,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },


    // 一键已读未读信息
    async oneClickRead(context, params) {
        const r = await Require({
            api: DB.oneClickRead,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 获取我的待办筛选状态列表
    async workflowStatusList(context, params) {
        const r = await Require({
            api: DB.workflowStatusList,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 获取我的待办筛选模块列表
    async workflowModuleList(context, params) {
        const r = await Require({
            api: DB.workflowModuleList,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 获取我的待办筛选模块列表
    async pendingList(context, params) {
        const r = await Require({
            api: DB.pendingList,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

    // 获取我的待办中待处理数量和抄送未读数量
    async workflowPendingInfo(context, params) {
        const r = await Require({
            api: DB.workflowPendingInfo,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}